import { useState } from 'react';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';

import { authApi, ApiError } from '../lib/api.js';
import { useUiStore } from '../lib/stores.js';

export default function ResetPasswordPage() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const openModal = useUiStore((s) => s.openModal);
  const token = params.get('token') || '';
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [busy, setBusy] = useState(false);
  const [status, setStatus] = useState(token ? 'form' : 'missing');
  const [errorMessage, setErrorMessage] = useState('');

  const submit = async (event) => {
    event.preventDefault();
    setErrorMessage('');
    if (password.length < 10) {
      setErrorMessage('Password must be at least 10 characters.');
      return;
    }
    if (password !== confirmPassword) {
      setErrorMessage('Passwords do not match.');
      return;
    }
    setBusy(true);
    try {
      await authApi.passwordResetConfirm({ token, password });
      setStatus('ok');
      setTimeout(() => {
        openModal('login');
        navigate('/', { replace: true });
      }, 900);
    } catch (err) {
      setErrorMessage(err instanceof ApiError ? err.message : 'Could not reset password.');
    } finally {
      setBusy(false);
    }
  };

  return (
    <div style={{ maxWidth: 480, margin: '12vh auto', padding: '0 24px', textAlign: 'center' }}>
      <h1>Reset password</h1>
      {status === 'missing' && (
        <>
          <p>No reset token in URL.</p>
          <p className="muted">
            <Link to="/">Back to the app</Link> - use Forgot password to request a new link.
          </p>
        </>
      )}
      {status === 'ok' && (
        <>
          <p>Password updated.</p>
          <p className="muted">Redirecting you to sign in.</p>
        </>
      )}
      {status === 'form' && (
        <form onSubmit={submit} style={{ display: 'flex', flexDirection: 'column', gap: 14, textAlign: 'left' }}>
          <p className="muted" style={{ textAlign: 'center' }}>Choose a new password for your account.</p>
          <label>
            <span>New password</span>
            <input
              className="input"
              type="password"
              required
              minLength={10}
              value={password}
              onChange={(event) => setPassword(event.target.value)}
              autoFocus
            />
          </label>
          <label>
            <span>Confirm password</span>
            <input
              className="input"
              type="password"
              required
              minLength={10}
              value={confirmPassword}
              onChange={(event) => setConfirmPassword(event.target.value)}
            />
          </label>
          {errorMessage && <div style={{ color: '#fca5a5', textAlign: 'center' }}>{errorMessage}</div>}
          <button type="submit" className="btn primary" disabled={busy}>
            {busy ? 'Updating...' : 'Set new password'}
          </button>
        </form>
      )}
    </div>
  );
}
